import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-trip',
  templateUrl: './dialog-trip.component.html',
  styleUrls: ['./dialog-trip.component.scss']
})
export class DialogTripComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogTripComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
